export default __webpack_public_path__ + "static/media/w2.3d7bbc99.png";